import React from "react";
import BoostContainer from "pages/Boost/components/BoostContainer";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const config = [
  {
    section: "TomoBoost",
    items: [
      {
        question: () => "What is TomoBoost?",
        answer: () => (
          <p>
            TomoBoost is a product we developed to help increase credit scores
            FAST. We also enhance this process through analyzing successful
            recurring payments.
          </p>
        ),
      },
      {
        question: () => "I don't see rent showing up.",
        answer: () => (
          <p>
            Our rent identification system is now out! If you still do not see
            your rent transaction showing up, you can add it manually under the
            &quot;Don&apos;t See your Bills?&quot; section within your
            dashboard.
          </p>
        ),
      },
      {
        question: () => "What payments qualify for boosting my score?",
        answer: () => (
          <p>
            Any recurring bill qualifies: This means Utilities (water bill,
            electricity bill, cable, gas bill, etc). Subscriptions (Netflix,
            Hulu, Spotify, etc). But not limited to these! Gym memberships,
            Rent, Car Insurance payments, and more.
          </p>
        ),
      },
      {
        question: () => "How long does it take to report?",
        answer: () => (
          <p>
            We report to all three major credit bureaus here in the U.S. on a
            monthly basis. Credit data is important so we have a thorough review
            process for quality reporting. Each bureau can have different
            reporting guidelines and timelines, one might report sooner than the
            others. This usually happens once a month, or at least every 45
            days. We recommend to wait a minimum 45 - 90 days.
          </p>
        ),
      },
      {
        question: () => "How much will my credit score go up?",
        answer: () => (
          <p>
            This depends on multiple factors outside of TomoBoost; however we
            have had users boost over 150 points! Depending on your membership
            tier, you will see different levels of positive impact on your
            credit score.
          </p>
        ),
      },
      {
        question: () => "My personal information is wrong.",
        answer: () => (
          <p>
            Please reach out to customer support to update your personal
            information.
          </p>
        ),
      },
      {
        question: () => "My bank or account is not supported.",
        answer: () => (
          <p>
            We use Finicity, a Mastercard Company to securely and privately
            access your positive bill payments, and some banks or accounts may
            not be supported. Most of the time this is out of our control - but
            if you have any banks you would like for us to put in a request to
            add, please contact support.
          </p>
        ),
      },
    ],
  },
];

const FaqSection = ({ name }) => {
  return (
    <h3 className="pt-8 pb-3 text-3xl font-bold text-boost-purple-alt">
      {name}
    </h3>
  );
};

const FaqItem = ({ question, answer }) => {
  return (
    <div className="w-full px-1 mb-1">
      <div className="accordion_wrap_boost">
        <AccordionItem className="accordion_item_boost">
          <AccordionItemHeading className="accordion_item_heading_boost">
            <AccordionItemButton className="accordion_item_button_boost">
              {question?.()}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion_item_panel_boost text-white">
            {answer?.()}
          </AccordionItemPanel>
        </AccordionItem>
      </div>
    </div>
  );
};

const BoostFaq = () => {
  return (
    <BoostContainer relative>
      <div className="flex pt-32 lg:pt-24 text-white">
        <main className="w-full pt-16">
          <section className="mb-5 px-10 max-w-page text-center py-5 text-white">
            <h1 className="text-3xl md:text-5xl font-extrabold w-10/12 mx-auto">
              TomoBoost - Frequently Asked Questions
            </h1>
            <p className="md:text-2xl font-light mt-2 w-full md:w-8/12 mx-auto">
              Find answers to common questions.
            </p>
          </section>
          <section className="max-w-page">
            <div>
              <Accordion allowZeroExpanded>
                <div className="w-11/12 md:w-11/12 lg:w-8/12 mx-auto mb-20">
                  {config.map(({ section, items }) => {
                    return (
                      <div key="tomoboost-faq">
                        <FaqSection key={section} name={section} />
                        {items.map((item, i) => {
                          return (
                            <FaqItem
                              // eslint-disable-next-line react/no-array-index-key
                              key={`${section}-${i}`}
                              question={item?.question}
                              answer={item?.answer}
                            />
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </Accordion>
            </div>
          </section>
        </main>
      </div>
    </BoostContainer>
  );
};

export default BoostFaq;
